import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, message, Modal } from 'antd';
import styled from 'styled-components';
import { LOGINPATH } from '../routes/routePaths';
import { removeItem } from '../utils/utils';
import { accessTokenKey, TEXT_SIZES } from '../utils/constants';

const { Title, Paragraph } = Typography;

interface SignOutProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const SignOut: React.FC<SignOutProps> = ({ open, setOpen }) => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    removeItem(accessTokenKey);
    message.success('You have been signed out successfully.');
    setOpen(false);
    // Redirect to login or home page after sign out
    navigate(LOGINPATH);
  };

  return (
    <Modal open={open} onCancel={() => setOpen(false)} footer={null}>
      <StyledTitle level={2}>Sign Out</StyledTitle>
      <StyledText>
        Are you sure you want to sign out? You will need to log in again to
        access your account.
      </StyledText>
      <StyledSignOutButton
        type="primary"
        danger
        block
        size="large"
        onClick={handleSignOut}
      >
        Confirm Sign Out
      </StyledSignOutButton>
    </Modal>
  );
};

const StyledTitle = styled(Title)`
  margin-bottom: 16px;
  text-align: center;
`;

const StyledText = styled(Paragraph)`
  margin-bottom: 24px;
  text-align: center;
  font-size: ${TEXT_SIZES.MD};
`;

const StyledSignOutButton = styled(Button)`
  margin-top: 8px;
`;

export default SignOut;
